import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-deceased-info-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-deceased-info-cm.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { ApplicationSearchConstants } from "../../../application-search-constants";
import { FormControl, FormGroup } from "@angular/forms";
import { ApplicationSearchService } from "../../../../shared/application-search.service";
import { NgbCalendar, NgbDate, NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { AflaModuleStrategyService } from "../../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../../app-controller.service";
import { SharedConstants } from "../../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../../shared/models/alert";
let SearchDeceasedInfoCmComponent = class SearchDeceasedInfoCmComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    calendar;
    formatter;
    noOfMonthsToDisplay;
    deceasedDetailsNameLabel = ApplicationSearchConstants.FORM_CONTROLS.nameLabel;
    deceasedDetailsSurnameLabel = ApplicationSearchConstants.FORM_CONTROLS.surnameLabel;
    deceasedDetailsIDNumberLabel = ApplicationSearchConstants.FORM_CONTROLS.idNumberLabel;
    deceasedDetailsDateOfDeathLabel = ApplicationSearchConstants.FORM_CONTROLS.dateOfDeathLabel;
    deceasedDetailsNameFormControl = ApplicationSearchConstants.FORM_CONTROLS.nameFormControl;
    deceasedDetailsSurnameFormControl = ApplicationSearchConstants.FORM_CONTROLS.surnameFormControl;
    deceasedDetailsIDNumberFormControl = ApplicationSearchConstants.FORM_CONTROLS.idNumberFormControl;
    deceasedDetailsDateOfDeathFormControl = ApplicationSearchConstants.FORM_CONTROLS.dateOfDeathFormControl;
    datePlaceholder = ApplicationSearchConstants.FORM_CONTROLS.datePlaceholder;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    dateOfDeath;
    deceasedDetailsForm;
    applicationSearchCallback;
    hoveredDate = null;
    constructor(applicationSearchService, aflaModuleStrategyService, appController, calendar, formatter) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.calendar = calendar;
        this.formatter = formatter;
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchApplication($event) {
        const name = this.deceasedDetailsForm.get(this.deceasedDetailsNameFormControl).value;
        const surname = this.deceasedDetailsForm.get(this.deceasedDetailsSurnameFormControl).value;
        const idNumber = this.deceasedDetailsForm.get(this.deceasedDetailsIDNumberFormControl).value;
        const dateOfDeath = this.dateOfDeath ? new Date(this.dateOfDeath.year, this.dateOfDeath.month, this.dateOfDeath.day) : null;
        this.applicationSearchCallback(this.applicationSearchService.searchByDeceasedDetails(name, surname, idNumber, this.aflaModuleStrategyService, Number(this.appController.selectedModuleID), dateOfDeath ? dateOfDeath : null));
    }
    setUpForm() {
        this.deceasedDetailsForm = new FormGroup({
            nameFormControl: new FormControl(""),
            surnameFormControl: new FormControl(""),
            idNumberFormControl: new FormControl(""),
            dateOfDeathFormControl: new FormControl(null)
        });
    }
    validateInput(currentValue, input) {
        const parsed = this.formatter.parse(input);
        if (!parsed && input !== "") {
            this.appController.showMessage(`${SharedConstants.DATE_INPUT_CONTROL_VALIDATION}`, AlertType.Warning);
            return currentValue;
        }
        return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
    }
    isHovered(date) {
        return this.noOfMonthsToDisplay > 1
            ? this.dateOfDeath
                && this.hoveredDate
                && date.after(this.dateOfDeath)
                && date.before(this.hoveredDate)
            : false;
    }
    isInside(date) {
        return false;
    }
    isRange(date) {
        return this.noOfMonthsToDisplay > 1
            ? date.equals(this.dateOfDeath)
                || this.isInside(date)
                || this.isHovered(date)
            : false;
    }
    onDateSelection(date) {
        this.dateOfDeath = date;
    }
    clearDate() {
        this.dateOfDeath = null;
    }
    setAutoClose() {
        return "'outside'";
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: NgbCalendar },
        { type: NgbDateParserFormatter }
    ];
    static propDecorators = {
        noOfMonthsToDisplay: [{ type: Input }]
    };
};
SearchDeceasedInfoCmComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-deceased-info-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], SearchDeceasedInfoCmComponent);
export { SearchDeceasedInfoCmComponent };
